module.exports = __webpack_public_path__ + "static/media/blog-9.a24f1948.svg";